<template>
  <div>
    <div class="card-container">
      <div v-for="item in content" class="card" :style="{'marginBottom': bottom}" :key="item.filename" @click="downLoad(item)">
        <icon-svg icon-class="report" class="icon"></icon-svg>
        <div class="info">
          <p class="ellipsis title-news">{{item.originalName | changeName}}</p>
          <p class="time">{{time ? time : item.dataTime}}</p>
        </div>
      </div>
      <form :action="api" ref="downloadForm" target="_blank">
        <input type="hidden" ref="filename" name="filename" value="">
        <input type="hidden" ref="originalName" name="originalName" value="">
      </form>
    </div> 
    <p class="tips-msg">以上数据所有权归投保基金公司所有，如需转载或使用，请注明出处</p> 
  </div>  
</template>
<script>
export default {
  props: {
    bottom: {
      type: String,
      default: '30px'
    },
    api: {
      type: String
    },
    title: {
      type: String,
      default: '本月投资者信心调查专报'
    },
    time: {
      type: [String, Number],
      default: ''
    },
    content: {
      type: Array,
      default () {
        return []
      }
    }
  },
  methods: {
    downLoad (item) {
      this.$refs.filename.value = item.filename
      this.$refs.originalName.value = item.originalName
      this.$refs.downloadForm.submit()
    }
  },
  filters: {
    changeName (val) {
      if (val.lastIndexOf('.') !== -1) {
        return val.substring(0, val.lastIndexOf('.'))
      } else {
        return val
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card-container{
  display: flex;
  flex-wrap: wrap;
  .card{
    display: flex;
    height: 111px;
    padding: 30px;
    box-sizing: border-box;
    width:580px;
    background: #FFF;
    cursor: pointer;
    border:$border;
    &:nth-child(even){
      margin-left: 20px;
    }
    .info{
      flex: 1;
      overflow: hidden;
    }
    .icon{
      width: 50px;
      height: 50px;
      margin-right: 20px;
    }
    .time{
      color: #929292;
      margin-top: 10px;
    }
  }
}
.tips-msg{
  color: #666;
  text-align: center;
  line-height: 24px;
}
</style>
